module.exports = __webpack_public_path__ + "img/Gastroenterologist.187653a4.jpg";